/* eslint-disable */
import { isEmpty } from "../../utils";
import { IAuth } from "../auth/auth";
import { Axios } from "../axios";

export const sendA2Form = async (body: IReviewPage.SendA2FormProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(`/remit/auth/sendA2FromLink`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const saveEsign = async (body: FormData, userId: any) => {
  return await Axios.post(`/remit/users/${userId}/signedImage`, body);
};

export const validateEsignLink = async (body: IReviewPage.ValidateEsign) => {
  return await Axios.post(`/remit/auth/signature/check`, body);
};

export const getSignedStatus = async (body: IReviewPage.EsignStatus) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.get(`remit/user/signedStatus/user/${body.userId}`, {
    headers: {
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const signLaterStatus = async (body: IReviewPage.SignLaterStatus) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(`/remit/auth/signature/flag/doLater/${body.userId}`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const getVendorCode = async (currentUser: IAuth.IIsAuthorisedProps) => {
  return await Axios.get(`/remit/auth/masterVendorCode`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
    },
  });
};

export const getSalesTeam = async (currentUser: IAuth.IIsAuthorisedProps) => {
  return await Axios.get(`/remit/auth/salesTeamNameDetails`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
      "Access-Control-Allow-Origin": "true",
      "Content-Type": "application/json",
    },
  });
};

export const getContent = async (currentUser: IAuth.IIsAuthorisedProps, pageName: string) => {
  if (!(currentUser === null || currentUser === undefined || isEmpty(currentUser))) {
    return await Axios.get(`/remit/modal/content/get?pageName=${pageName}`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
        "Access-Control-Allow-Origin": "true",
        "Content-Type": "application/json",
      },
    });
  }
};
